export default __webpack_public_path__ + "static/media/welcome-side-menu-standard.5af42931.png";